// extracted by mini-css-extract-plugin
export var center = "_3z-2";
export var clickableRow = "_3z-5";
export var expandedRow = "_3z-7";
export var hoverable = "_3z-4";
export var left = "_3z-1";
export var right = "_3z-3";
export var row = "_3z-0";
export var selectedRow = "_3z-6";
export var summaryRow = "_3z-8";